(() => {
  const theme = window.Shopify?.theme;
  if (Number(theme?.id) !== 203656200535 || !['unpublished', 'development'].includes(theme?.role)) return;
  if (customElements.get('cooldo-social-proof-demo')) return;

  const girls = [
    'María', 'Lucía', 'Paula', 'Laura', 'Marta', 'Elena', 'Sara', 'Ana', 'Carla', 'Claudia',
    'Alba', 'Irene', 'Sofía', 'Julia', 'Carmen', 'Patricia', 'Isabel', 'Andrea', 'Raquel', 'Beatriz',
    'Silvia', 'Cristina', 'Nuria', 'Adriana', 'Rocío', 'Noelia', 'Lorena', 'Verónica', 'Alicia', 'Eva'
  ];
  const boys = [
    'Carlos', 'Pablo', 'Javier', 'David', 'Daniel', 'Alejandro', 'Álvaro', 'Adrián', 'Sergio', 'Manuel',
    'Antonio', 'José', 'Miguel', 'Juan', 'Pedro', 'Jorge', 'Diego', 'Rubén', 'Marcos', 'Jaime',
    'Raúl', 'Alberto', 'Fernando', 'Víctor', 'Héctor', 'Óscar', 'Enrique', 'Andrés', 'Francisco', 'Luis'
  ];
  const memory = new Map();
  const pick = (names, previous) => {
    const choices = names.filter((name) => name !== previous);
    return choices[Math.floor(Math.random() * choices.length)];
  };
  const localDay = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  };
  const validState = (state) => state?.version === 1
    && girls.includes(state.girl)
    && boys.includes(state.boy)
    && Number.isInteger(state.count)
    && state.count >= 120 && state.count <= 550
    && typeof state.day === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(state.day);
  const getState = (productId) => {
    const key = `cooldo:prototype:social-proof:v1:${productId}`;
    const today = localDay();
    let state = memory.get(key);
    try {
      const stored = window.localStorage.getItem(key);
      if (stored !== null) state = JSON.parse(stored);
    } catch {}

    if (!validState(state)) {
      state = { version: 1, girl: pick(girls), boy: pick(boys), count: 120 + Math.floor(Math.random() * 431), day: today };
    } else if (today > state.day) {
      state = { ...state, girl: pick(girls, state.girl), boy: pick(boys, state.boy), count: Math.min(550, state.count + 2), day: today };
    }
    memory.set(key, state);
    try {
      const serialized = JSON.stringify(state);
      if (window.localStorage.getItem(key) !== serialized) window.localStorage.setItem(key, serialized);
    } catch {}
    return state;
  };

  class CooldoSocialProofDemo extends HTMLElement {
    constructor() {
      super();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onReturn = () => {
        if (document.visibilityState === 'hidden') this.finishTyping();
        else this.render();
      };
      this.onMotionChange = () => {
        if (this.reducedMotion.matches) this.finishTyping();
      };
    }

    connectedCallback() {
      this.render();
      window.addEventListener('pageshow', this.onReturn);
      document.addEventListener('visibilitychange', this.onReturn);
      this.reducedMotion.addEventListener('change', this.onMotionChange);
    }

    disconnectedCallback() {
      window.removeEventListener('pageshow', this.onReturn);
      document.removeEventListener('visibilitychange', this.onReturn);
      this.reducedMotion.removeEventListener('change', this.onMotionChange);
      this.finishTyping();
    }

    finishTyping() {
      this.visibilityObserver?.disconnect();
      if (this.typingFrame != null) window.cancelAnimationFrame(this.typingFrame);
      this.typingFrame = null;
      this.typingParts?.forEach(({ element, text }) => { element.textContent = text; });
      this.typingParts = null;
    }

    animateMessage() {
      if (this.reducedMotion.matches || !window.requestAnimationFrame) return;
      const characters = [];
      this.typingParts = ['[data-social-proof-names]', '[data-social-proof-copy]'].map((selector) => {
        const element = this.querySelector(selector);
        const text = element.textContent;
        const fragment = document.createDocumentFragment();
        for (const character of Array.from(text)) {
          const letter = document.createElement('span');
          letter.textContent = character;
          letter.style.opacity = '0';
          fragment.appendChild(letter);
          characters.push(letter);
        }
        element.replaceChildren(fragment);
        return { element, text };
      });
      const play = () => {
        if (!this.isConnected || this.reducedMotion.matches) {
          this.finishTyping();
          return;
        }
        const duration = Math.min(1100, Math.max(700, characters.length * 14));
        let startedAt;
        let revealed = 0;
        let cursor;
        const tick = (timestamp) => {
          if (!this.isConnected || this.reducedMotion.matches || document.visibilityState === 'hidden') {
            this.finishTyping();
            return;
          }
          startedAt ??= timestamp;
          const progress = Math.min(1, (timestamp - startedAt) / duration);
          const count = Math.min(characters.length, Math.floor(progress * characters.length) + 1);
          if (count > revealed) {
            cursor?.style.removeProperty('box-shadow');
            while (revealed < count) characters[revealed++].style.opacity = '1';
            cursor = characters[revealed - 1];
            if (cursor) cursor.style.boxShadow = '1px 0 0 currentColor';
          }
          if (progress === 1) this.finishTyping();
          else this.typingFrame = window.requestAnimationFrame(tick);
        };
        this.typingFrame = window.requestAnimationFrame(tick);
      };
      if (!window.IntersectionObserver) {
        play();
        return;
      }
      this.visibilityObserver = new window.IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.25)) return;
        this.visibilityObserver.disconnect();
        play();
      }, { threshold: 0.25 });
      this.visibilityObserver.observe(this);
    }

    render() {
      const names = this.querySelector('[data-social-proof-names]');
      const copy = this.querySelector('[data-social-proof-copy]');
      if (!names || !copy || !this.dataset.productId || !this.dataset.copyTemplate) return;
      const state = getState(this.dataset.productId);
      const namesText = `${state.girl}, ${state.boy}`;
      const copyText = this.dataset.copyTemplate.replace('__COUNT__', String(state.count));
      this.style.removeProperty('display');
      const message = `${namesText}|${copyText}`;
      if (this.lastMessage === message) return;
      this.finishTyping();
      names.textContent = namesText;
      copy.textContent = copyText;
      this.lastMessage = message;
      this.animateMessage();
    }
  }

  customElements.define('cooldo-social-proof-demo', CooldoSocialProofDemo);
})();
